import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './config/env' // Fail-fast on missing env vars at startup.
import { bootstrapAuth } from '@dfq/shared/auth'
import { ThemeProvider } from '@dfq/shared/components/ThemeProvider'
import { store } from '@dfq/shared/stores/index'
import { fetchCart } from '@dfq/shared/stores/cart'
import './index.css'
import App from './App.tsx'

// Strip server-rendered SEO tags before React mounts — prevents duplicates
// because React 19 native hoisting adds new tags rather than replacing them
// in createRoot (non-hydrateRoot) SPA mode.
document.querySelectorAll('[data-dfq-seo]').forEach((el) => el.remove())

// bootstrapAuth is async (SF-AUTH-PERSIST): awaiting it ensures that a
// cookie-based silent refresh settles before `RequireAuth` guards evaluate.
// The `bootPhase` Redux field gates the guards independently, so mounting
// the React tree before await is also safe — but waiting keeps the boot
// path simple and avoids a flash of the loading state on fast networks.
bootstrapAuth(store, { clientType: 'storefront' }).then(() => {
  // Rehydrate the cart once auth has settled so a hard refresh on ANY page
  // restores cart contents — not just the localStorage badge count, which the
  // header reads before the first /cart or /checkout view dispatches fetchCart.
  // Running after bootstrapAuth means a logged-in user fetches their user cart
  // (token already restored) rather than the guest session cart.
  void store.dispatch(fetchCart())

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StrictMode>,
  )
})
